<template>
  <div class="columns">
    <div class="column">
      <label class="label">Yours</label>
      <ul>
        <li class="action-row">
          <span class="action-checkbox" :class="{ checked: localChecked }">
            <b-icon icon="check" size="is-small" v-if="localChecked" />
          </span>
          <span class="action-label">Done</span>
        </li>
      </ul>
    </div>

    <div class="column">
      <label class="label">Theirs</label>
      <ul>
        <li class="action-row">
          <span class="action-checkbox" :class="{ checked: serverChecked }">
            <b-icon icon="check" size="is-small" v-if="serverChecked" />
          </span>
          <span class="action-label">Done</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConflictInstructionActionField',
  props: {
    local: {
      type: Boolean,
      default: false,
    },
    server: {
      type: Boolean,
      default: false,
    },
    resolved: {
      type: String,
      default: '',
    },
    module: {
      type: String,
      default: 'publisher',
    },
  },
  computed: {
    localChecked() {
      return !!this.local;
    },
    serverChecked() {
      return !!this.server;
    },
  },
};
</script>

<style scoped>
ul {
  margin: 0;
  padding-left: 0;
}

li.action-row {
  list-style: none;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 0.5em;
}

.action-checkbox {
  width: 24px;
  height: 24px;
  border: 2px solid #ccc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  flex-shrink: 0;
}

.action-checkbox.checked {
  background: #23d160;
  border-color: #23d160;
  color: #fff;
}

.action-label {
  font-size: 1rem;
  color: #4a4a4a;
  font-weight: bold;
}
</style>
